import type { SearchCriteria, PartialSearchCriteria } from '../../model/types';

interface MealsParams {
  meal?: string;
}

export function meals(criteria: SearchCriteria | PartialSearchCriteria): MealsParams {
  if (criteria.meals?.length) {
    return { meal: criteria.meals.join('.') };
  }
  return {};
}
